import { defineComponent as _defineComponent } from 'vue'
import VLoader from './loader.vue'
import QRCode from 'qrcode'
import { onMounted, ref, watch } from 'vue';

type Props = {
    message: string,
    logoStyle?: 'square' | 'circle'
}
type Emits = {
    (e: "readychange", ready: boolean): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'QrCode',
  props: {
    message: null,
    logoStyle: null
  },
  emits: ["readychange"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: "readychange", ready: boolean): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as { message: string, logoStyle?: 'square' | 'circle' }





const loading = ref(false);

const canvas = ref<HTMLCanvasElement | null>();
const context = ref<CanvasRenderingContext2D | null>();

const OPT_CLOCK_SVG = "M12 0C5.3868 0 0 5.3868 0 12C0 18.6132 5.3868 24 12 24C18.6132 24 24 18.6132 24 12C24 5.3868 18.6132 0 12 0ZM12 2.4C17.3161 2.4 21.6 6.68385 21.6 12C21.6 17.3161 17.3161 21.6 12 21.6C6.68385 21.6 2.4 17.3161 2.4 12C2.4 6.68385 6.68385 2.4 12 2.4ZM10.8 4.8V12.4969L15.9516 17.6484L17.6484 15.9516L13.2 11.5031V4.8H10.8Z"
const OPT_CLOCK_COLOR = "#e23d35"

const OPT_CLOCK_PATH = new Path2D(OPT_CLOCK_SVG);

const drawOptClock = (ctx: CanvasRenderingContext2D, {clockSize = 50, padding = 10, logoStyle = 'square'}: {clockSize?: number, padding?: number, logoStyle?: 'square' | 'circle'}) => {
    ctx.save();

    const midPoint = ctx.canvas.width / 2;
    const drawPoint = midPoint - (clockSize / 2);

    ctx.fillStyle = "white"
    if(logoStyle === 'square') {
        ctx.translate(drawPoint - padding, drawPoint - padding);
        ctx.fillRect(0, 0, clockSize + 2 * padding, clockSize + 2 * padding);
    } else {
        const radius = (clockSize + 2 * padding) / 2;
        ctx.imageSmoothingEnabled = true;
        ctx.translate(midPoint, midPoint);
        ctx.ellipse(0, 0, radius, radius, 0, 0, 2 * Math.PI);
        ctx.fill();
    }
    ctx.restore();
    ctx.save();

    ctx.translate(drawPoint, drawPoint);

    ctx.scale(clockSize / 24, clockSize / 24);

    ctx.imageSmoothingEnabled = true;
    ctx.fillStyle = OPT_CLOCK_COLOR;
    ctx.fill(OPT_CLOCK_PATH);

    ctx.restore();
}

const drawQRCode = async () => {
    loading.value = true;
    emit('readychange', false);
    const code = await QRCode.toDataURL(props.message, {'errorCorrectionLevel': 'H'});
    const tmp = new Image();
    tmp.src = code;

    requestAnimationFrame(() => {
        if(!context.value) return;
        const ctx = context.value;
        ctx.imageSmoothingEnabled = false;
        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        ctx.drawImage(tmp, 0, 0, ctx.canvas.width, ctx.canvas.height);
        drawOptClock(ctx, {clockSize: 50, logoStyle: props.logoStyle});
        loading.value = false;
        emit('readychange', true);
    })
}

onMounted(() => {
    if(canvas.value) {
        context.value = canvas.value.getContext('2d');
        drawQRCode();
    }
})

watch(() => [props.message, props.logoStyle], () => drawQRCode());

const __returned__ = { props, emit, loading, canvas, context, OPT_CLOCK_SVG, OPT_CLOCK_COLOR, OPT_CLOCK_PATH, drawOptClock, drawQRCode, VLoader, QRCode, onMounted, ref, watch }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})